import React from 'react';
import './lms.css';

const features = [
  {
    title: 'GyanvAI React Assessment',
    image: 'https://gyanvai.com/assets/gyanvlogo-aRVOkX3U.jpeg',
    description: [
      'Interactive platform for React practice.',
      'Problems curated by top industry experts.',
      'Showcase skills for job recruitment.',
      ],
    link: 'https://gyanvai.com/',
  },
  {
    title: 'GyanvAI Express API Development',
    image: 'https://gyanvai.com/assets/gyanvlogo-aRVOkX3U.jpeg',
    description: [
      'Beginner-friendly express API development.',
      'Modern web development problem sets. based on express api',
      'Hands-on assignments to accelerate skills.',
    ],
    link: 'https://gyanvai.com/',
  },
  {
    title: 'GyanvAI web Designing Learning',
    image: 'https://gyanvai.com/assets/gyanvlogo-aRVOkX3U.jpeg',
    description: [
      'Test your skills to develop modern web pages using html5 and CSS .',
      'Practice and test your skills in control environment',
      'Tackle real-world data management challenges.',
    ],
    link: 'https://gyanvai.com/',
  },
  {
    title: 'AI interview',
    image: 'https://gyanvai.com/assets/gyanvlogo-aRVOkX3U.jpeg',
    description: [
      'Prepare well using AI interview in proctored environment',
      'Check performance and analysis report',
      'Real time evalution by AI Agent',
    ],
    link: 'https://gyanvai.com/',
  },
  {
    title: 'Enhance programming skills in proctored environment',
    image: 'https://gyanvai.com/assets/gyanvlogo-aRVOkX3U.jpeg',
    description: [
      'GyanvAI IDE for 20+ programming languages.',
      'Write, test, debug all in one place.',
      'Built-in debugger and execution tools.',
    ],
    link: 'https://gyanvai.com/',
  },
  {
    title: 'Assessment using MCQ',
    image: 'https://gyanvai.com/assets/gyanvlogo-aRVOkX3U.jpeg',
    description: [
      'MCQ Exam in Proctored Environment',
      'Question wise analysis report',
    ],
    link: 'https://gyanvai.com/',
  },
  
  
];

function Lms() {
  return (
    <div className="lms-container">
      <h2 className="lms-title">Learn. Practice. Earn. Have Fun! — with GyanvAI 🚀</h2>

      {/* Mobile Accordion View */}
      <div className="lms-mobile">
        {features.map((item, index) => (
          <details className="accordion" key={index}>
            <summary>{item.title}</summary>
            <img src={item.image} alt={item.title} />
            <h3>{item.title}</h3>
            <ul>
              {item.description.map((point, i) => (
                <li key={i}>{point}</li>
              ))}
            </ul>
            <a href={item.link} className="btn">Explore {item.title}</a>
          </details>
        ))}
      </div>

      {/* Desktop Tab View */}
      <div className="lms-desktop">
        <div className="tabs">
          {features.map((item, i) => (
            <input
              type="radio"
              name="tabs"
              id={`tab-${i}`}
              key={i}
              defaultChecked={i === 0}
            />
          ))}

          <div className="tab-labels">
            {features.map((item, i) => (
              <label htmlFor={`tab-${i}`} key={i} className="tab">
                {item.title}
              </label>
            ))}
          </div>

          <div className="tab-content">
            {features.map((item, i) => (
              <div className="content" key={i}>
                <img src={item.image} alt={item.title} />
                <div>
                  <h3>{item.title}</h3>
                  <ul>
                    {item.description.map((point, j) => (
                      <li key={j}>{point}</li>
                    ))}
                  </ul>
                  <a href={item.link} className="btn">Explore {item.title}</a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Lms;
